import { useRef, useEffect, useState } from "react";

const steps = [
  { num:"01", emoji:"👤", title:"Admin creates accounts", desc:"Admin adds Carpenters to the platform with login credentials and sets up their access." },
  { num:"02", emoji:"🔨", title:"Carpenter adds Labours",  desc:"Each Carpenter adds their labourers with daily rates, overtime rate and basic details." },
  { num:"03", emoji:"📅", title:"Daily Attendance",         desc:"Mark attendance every day — full day, half day, overtime, absent, holiday or leave." },
  { num:"04", emoji:"💰", title:"Salary & PDF",             desc:"View salary breakdown, record advance payments, and export a professional PDF report." },
];

export default function HowItWorks() {
  const ref = useRef(null);
  const [vis, setVis] = useState(false);

  useEffect(() => {
    const obs = new IntersectionObserver(([e]) => { if (e.isIntersecting) setVis(true); }, { threshold:.12 });
    if (ref.current) obs.observe(ref.current);
    return () => obs.disconnect();
  }, []);

  return (
    <section ref={ref} style={{ padding:"88px 5vw", background:"#fff" }}>
      <div style={{ maxWidth:"1200px", margin:"0 auto" }}>

        {/* Header */}
        <div style={{ textAlign:"center", opacity:vis?1:0, transform:vis?"translateY(0)":"translateY(28px)", transition:"all .6s" }}>
          <p style={{ fontSize:"11px", fontWeight:800, color:"#D97706", letterSpacing:"1.5px", textTransform:"uppercase", marginBottom:"10px" }}>How it works</p>
          <h2 style={{ fontFamily:"'Fraunces',serif", fontSize:"clamp(28px,4vw,44px)", fontWeight:900, color:"#1C1917", marginBottom:"14px" }}>
            Up and running in minutes
          </h2>
          <p style={{ fontSize:"16px", color:"#78716C", maxWidth:"460px", margin:"0 auto", lineHeight:1.6 }}>
            Simple 4-step process — from setup to salary, everything flows smoothly.
          </p>
        </div>

        {/* Steps */}
        <div style={{ display:"grid", gridTemplateColumns:"repeat(auto-fit,minmax(220px,1fr))", gap:"24px", marginTop:"60px", position:"relative" }}>
          {/* Connecting line desktop */}
          <div style={{ position:"absolute", top:"40px", left:"12%", right:"12%", height:"2px", background:"linear-gradient(90deg,transparent,#FDE68A,#D97706,#FDE68A,transparent)", pointerEvents:"none" }} />

          {steps.map((s, i) => (
            <div
              key={s.num}
              style={{
                textAlign:"center", padding:"0 16px",
                opacity:vis?1:0, transform:vis?"translateY(0)":"translateY(32px)",
                transition:`opacity .55s ${i*0.1}s, transform .55s ${i*0.1}s`,
              }}>
              {/* Circle */}
              <div style={{
                width:"72px", height:"72px", borderRadius:"50%",
                background:"linear-gradient(135deg,#92400E,#D97706)",
                display:"flex", alignItems:"center", justifyContent:"center",
                margin:"0 auto 20px",
                boxShadow:"0 8px 24px rgba(180,83,9,.3)",
                fontSize:"28px",
                position:"relative", zIndex:1,
              }}>
                {s.emoji}
              </div>

              {/* Step number */}
              <span style={{
                display:"inline-block", padding:"2px 10px", borderRadius:"20px",
                background:"#FEF3C7", border:"1px solid #FDE68A",
                fontSize:"11px", fontWeight:800, color:"#D97706",
                marginBottom:"10px",
              }}>
                Step {s.num}
              </span>

              <p style={{ fontSize:"16px", fontWeight:800, color:"#1C1917", marginBottom:"8px" }}>{s.title}</p>
              <p style={{ fontSize:"13px", color:"#78716C", lineHeight:1.65 }}>{s.desc}</p>
            </div>
          ))}
        </div>

        {/* Bottom stat strip */}
        <div style={{
          marginTop:"60px", padding:"28px 32px",
          background:"#1C1917", borderRadius:"20px",
          display:"grid", gridTemplateColumns:"repeat(auto-fit,minmax(140px,1fr))",
          gap:"24px", textAlign:"center",
          opacity:vis?1:0, transform:vis?"translateY(0)":"translateY(20px)",
          transition:"all .6s .4s",
        }}>
          {[
            { val:"3",   label:"User Roles" },
            { val:"6",   label:"Attendance Types" },
            { val:"∞",   label:"Labours Supported" },
            { val:"PDF", label:"Export Reports" },
          ].map(s => (
            <div key={s.label}>
              <p style={{ fontFamily:"'Fraunces',serif", fontSize:"32px", fontWeight:900, color:"#D97706", marginBottom:"4px" }}>{s.val}</p>
              <p style={{ fontSize:"12px", fontWeight:700, color:"#A8A29E" }}>{s.label}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}